import { render, staticRenderFns } from "./ImageComponent.vue?vue&type=template&id=9bba0726&"
import script from "./ImageComponent.vue?vue&type=script&lang=js&"
export * from "./ImageComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImageComponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports